/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audit_Total_ItemsInputs */

const en_audit_total_items = /** @type {(inputs: Audit_Total_ItemsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total items`)
};

const es_audit_total_items = /** @type {(inputs: Audit_Total_ItemsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total de articulos`)
};

/**
* | output |
* | --- |
* | "Total items" |
*
* @param {Audit_Total_ItemsInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const audit_total_items = /** @type {((inputs?: Audit_Total_ItemsInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_Total_ItemsInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_audit_total_items(inputs)
	return es_audit_total_items(inputs)
});